import bildJa from '@/assets/icons/ja.svg';
import bildNein from '@/assets/icons/nein.svg';

export const alreadyBuiltAnswers = [
    { name: 'Ja', available: true, value: 'ja', api: '22461', image: bildJa },
    { name: 'Nein', available: false, value: 'nein', api: '22462',  image: bildNein },
];

export const alreadyBuiltApi = {parameter: '19373', type: 'value_choice'};